// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhb_a","AdSlotBranding__desktop":"bhb_b","AdSlotBranding__mobile":"bhb_c"};